import { __assign } from "tslib";
import { Col } from 'react-bootstrap';
import { Editable, withReact, Slate } from 'slate-react';
import { createEditor } from 'slate';
import { useCallback, useMemo, useState, useEffect } from 'react';
import { withHistory } from 'slate-history';
import { EditModal } from './Modal';
import { AlingMenu, ListMenu, TabsMenu, TypeMenu } from './BlockProps';
import { defaultBlock, getText, setText as st } from './Data';
import { Element } from './Element';
import { Leaf } from './Mark';
import { ColorButton, BackButton, FontStyle, MarkMenu } from './MarkProps';
import { hotKeysValue } from './HotKeys';
import { VerElement, VerLeaf } from './Ver';
import React from 'react';
export { EditModal };
export var Texto = function (_a) {
    var value = _a.value, onChange = _a.onChange, id = _a.id, colores = _a.colores, error = _a.error;
    var renderElement = useCallback(function (props) { return React.createElement(Element, __assign({}, props)); }, []);
    var renderLeaf = useCallback(function (props) { return React.createElement(Leaf, __assign({}, props)); }, []);
    var editor = useMemo(function () { return withHistory(withReact(createEditor())); }, []);
    var _b = useState(value.length ? st(value) : defaultBlock), text = _b[0], setText = _b[1];
    var _c = useState(false), up = _c[0], setUP = _c[1];
    var setHtml = useCallback(function () { return onChange(getText(text)); }, [text, onChange]);
    useEffect(function () { setTimeout(function () { return setUP(!up); }, 1); }, [text]);
    useEffect(function () { return setHtml(); }, [up]);
    return React.createElement(Slate, { editor: editor, value: text, onChange: setText },
        React.createElement(Col, { className: 'd-flex', xs: 12 },
            React.createElement(MarkMenu, null),
            React.createElement(ColorButton, { colores: colores }),
            React.createElement(BackButton, { colores: colores }),
            React.createElement(AlingMenu, null),
            React.createElement(TabsMenu, null),
            React.createElement(ListMenu, null),
            React.createElement(TypeMenu, null),
            React.createElement(FontStyle, null)),
        React.createElement(Col, { xs: 12, className: 'mt-1' },
            error ? React.createElement("small", { style: { color: '#dc3545' } }, error) : React.createElement(React.Fragment, null),
            React.createElement(Editable, { id: 'slate' + id, key: '' + Math.random(), spellCheck: true, renderElement: renderElement, renderLeaf: renderLeaf, onKeyDown: function (event) { return hotKeysValue(editor, event); }, style: {
                    padding: '.5rem .5rem .5rem .5rem', width: '100%', minWidth: '100px', maxHeight: '70vh',
                    border: error ? 'solid 1px #dc3545' : 'solid 1px #ced4da', overflowX: 'hidden',
                    minHeight: '30px', overflowY: 'auto', borderRadius: '.25rem'
                } })));
};
export function TextToHTML(_a) {
    var text = _a.text;
    return React.createElement(React.Fragment, null, text.map(function (e) { return (React.createElement(VerElement, { key: JSON.stringify(e), element: e }, e.children.map(function (a) { return (React.createElement(VerLeaf, { key: a.text, leaf: a })); }))); }));
}
//# sourceMappingURL=Main.js.map